import { ChangeDetectionStrategy, Component, inject, input, output, viewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IncidentFormControls } from 'src/app/types';
import { PanFilepickerComponent } from '../../../../../components/pan-filepicker/pan-filepicker.component';
import { ModalService } from '../../../../../components/pan-modal/modal.service';
import { ReviewFormService } from '../review-form.service';

@Component({
  selector: 'app-review-form-transaction-reports',
  templateUrl: './review-form-transaction-reports.component.html',
  styleUrl: './review-form-transaction-reports.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ReviewFormTransactionReportsComponent {
  private modalService = inject(ModalService);
  public formService = inject(ReviewFormService);

  private uploadField = viewChild<PanFilepickerComponent>('uploadField');

  public form = input.required<FormGroup<IncidentFormControls>>();
  public isRequired = input<boolean>(false);
  public imageUrls = input<string[]>([]);
  public upload = output<File[]>();

  public reset(): void {
    this.uploadField()?.clear();
  }

  public removeLink(link: string): void {
    const control = this.formService.form.controls.existingReports;
    const index = control.value.indexOf(link);
    if (index !== -1) control.removeAt(index);
  }

  public removeImageUrl(imageUrl: string): void {
    const index = this.imageUrls().indexOf(imageUrl);
    if (index === -1) return;
    this.formService.removeFileAt(this.formService.form.controls.reports, this.formService.uniqueTransactionPhotoUrls, index);
    this.modalService.removeModal();
  }
}
